<div *ngIf="checklist" id="checklistModifyBody" [ngClass]="{'border-outline': isProjectInput}">
  <h3 *ngIf="isProjectInput" class="outline-border-header">{{'PROJECT.INITIAL.INPUT_LIST.TITLE' | anessaTranslation: trigger}}</h3>
  <form
    #checklistForm="ngForm"
    (mouseenter)="showClearName = true"
    (mouseleave)="showClearName = false"
    class="flex-container edit-inline-row form-field-container">
    <mat-form-field appearance="outline" *ngIf="showTitle" floatLabel="always">
      <mat-label>{{'PROJECT.PROJECT_INFO.CHECKLIST.NAME' | anessaTranslation: trigger}}</mat-label>
      <input
        matInput
        required
        [(ngModel)]="checklist.name"
        [readonly]="isInitialUser || editOnlyInitialChecklists || readOnlyInitialChecklists"
        name="title"
        type="text">
    </mat-form-field>
    <p
      *ngIf="checklist.name && showClearName && !readOnlyInitialChecklists  || editOnlyInitialChecklists"
      class="form-field-clear"
      (click)="clearInput('name')"
      anessaTranslation="PROJECT.COMMON.CLEAR">
    </p>
  </form>

  <div class="wrapped-button-container" *ngIf="!isInitialUser && !readOnlyInitialChecklists && !editOnlyInitialChecklists">
    <button
      mat-raised-button
      class="wrapped-button"
      matTooltip="only excel files can be uploaded"
      onclick="document.getElementById('fileUploadInput').click()">
      {{'PROJECT.PROJECT_INFO.CHECKLIST.IMPORT' | anessaTranslation: trigger}}
    </button>
    <input
      #fileInput
      id="fileUploadInput"
      hidden
      type="file"
      accept=".xlsx"
      (change)="importData($event.target)">
    <button
      *ngIf="editMode"
      mat-raised-button
      class="wrapped-button"
      (click)="exportData()">
      {{'PROJECT.PROJECT_INFO.CHECKLIST.EXPORT' | anessaTranslation: trigger}}
    </button>
    <button
      *ngIf="editMode"
      mat-raised-button
      class="wrapped-button"
      (click)="downloadTemplate()">
      <span>{{'PROJECT.PROJECT_INFO.CHECKLIST.DOWNLOAD_TEMPLATE' | anessaTranslation: trigger}}</span>
    </button>
    <button
      mat-raised-button
      class="wrapped-button"
      (click)="onSaveAsTemplate()">
      {{'PROJECT.PROJECT_INFO.CHECKLIST.SAVE_AS_TEMPLATE' | anessaTranslation: trigger}}
    </button>
    <button
      *ngIf="editMode"
      mat-raised-button
      class="wrapped-button"
      (click)="onLoadFromTemplateClick()">
      {{'PROJECT.PROJECT_INFO.CHECKLIST.LOAD_FROM_TEMPLATE' | anessaTranslation: trigger}}
    </button>
    <button
      mat-raised-button
      class="wrapped-button"
      (click)="toggleEdit()">
      <ng-container *ngIf="!editMode">{{'PROJECT.PROJECT_INFO.CHECKLIST.ENABLE_EDIT_MODE' | anessaTranslation: trigger}}</ng-container>
      <ng-container *ngIf="editMode">{{'PROJECT.PROJECT_INFO.CHECKLIST.DISABLE_EDIT_MODE' | anessaTranslation: trigger}}</ng-container>
    </button>
  </div>

  <div *ngIf="showTable" #tableBody class="table-container">
    <table mat-table [dataSource]="dataSource">

      <!-- Empty cell -->
      <ng-container matColumnDef="intEmptyAdd" >
        <th mat-header-cell class="empty-a" *matHeaderCellDef style="border: none;"></th>
      </ng-container>

      <!-- Empty cell -->
      <ng-container matColumnDef="intEmptyLevel" >
        <th mat-header-cell class="empty-a" *matHeaderCellDef>
          <button
            *ngIf="editMode"
            mat-icon-button
            disableRipple
            class="clickable"
            color="accent"
            (click)="onAddColumn(-1)">
            <mat-icon>add</mat-icon>
          </button>
        </th>
      </ng-container>

      <!-- Empty cell -->
      <ng-container matColumnDef="intEmptyId" >
        <th mat-header-cell class="empty-a" *matHeaderCellDef></th>
      </ng-container>

      <!-- Column Controls -->
      <ng-container *ngFor="let column of controlNames; let i = index;" >
        <ng-container matColumnDef="{{ column }}">
          <th mat-header-cell *matHeaderCellDef class="empty-a">
            <div class="flex-container">
              <button mat-icon-button class="flex-1" style="visibility: hidden;">
                <mat-icon>masks</mat-icon>
              </button>
              <button
                *ngIf="editMode"
                mat-icon-button
                disableRipple
                class="flex-1 clickable"
                color="warn"
                (click)="onRemoveColumn(i)">
                <mat-icon>clear</mat-icon>
              </button>
              <button
                *ngIf="editMode"
                mat-icon-button
                disableRipple
                class="flex-1 clickable"
                color="accent"
                (click)="onAddColumn(i)">
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </th>
        </ng-container>
      </ng-container>

      <!-- Empty cell -->
      <ng-container matColumnDef="intEmptyRemove">
        <th mat-header-cell class="empty-a" *matHeaderCellDef style="border: none;"></th>
      </ng-container>

      <!-- Add Control Column -->
      <ng-container matColumnDef="addControl">
        <th mat-header-cell *matHeaderCellDef>
          <div class="flex-td padding-right-16">
            <button
              *ngIf="editMode"
              disabled
              mat-icon-button
              disableRipple>
              <mat-icon></mat-icon>
            </button>
            <button
              *ngIf="editMode"
              mat-icon-button
              disableRipple
              class="clickable"
              color="accent"
              (click)="onAddRow(-1)">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let i = index;">
          <div class="flex-td max-input-width">
            <button
              *ngIf="editMode"
              mat-icon-button
              disableRipple
              class="clickable"
              (click)="onEditRow(i)">
              <mat-icon class="anessa-grey">edit_note</mat-icon>
            </button>
            <button
              *ngIf="editMode"
              mat-icon-button
              disableRipple
              class="clickable"
              color="accent"
              (click)="onAddRow(i)">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <!-- Level Control Column -->
      <ng-container matColumnDef="levelControl" *ngIf="editMode">
        <th mat-header-cell *matHeaderCellDef class="level-select">
          <mat-form-field floatLabel="never">
            <mat-select
              [(ngModel)]="maxLevelShown"
              [disabled]="readOnlyInitialChecklists"
              (ngModelChange)="onMaxLevelChange();"
              [placeholder]="('PROJECT.COMMON.PLEASE_SELECT' | anessaTranslation: trigger)">
              <mat-option
                *ngFor="let level of getLevels(getMaxLevel())"
                [value]="level">
                {{ level }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element; let i = index;" class="level-select">
          <mat-form-field
            floatLabel="never">
            <mat-select
              [value]="element.level"
              (selectionChange)="onLevelChange(i, $event.value);"
              [disabled]="readOnlyInitialChecklists"
              [placeholder]="('PROJECT.COMMON.PLEASE_SELECT' | anessaTranslation: trigger)">
              <mat-option
                *ngFor="let level of getLevels(element.level, element, false)"
                [value]="level">
                {{ level }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <!-- ID Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef></th>
        <td
          mat-cell
          *matCellDef="let element;"
          class="id-column max-input-width"
          [ngStyle]="getRowStyle(element)">
          <span>
            {{ element.data['id'] }}
          </span>
        </td>
      </ng-container>

      <!-- Item Columns -->
      <ng-container *ngFor="let columnName of columnNames; let colIndex = index;">
        <ng-container matColumnDef="{{ columnName }}">
          <!-- dont do anything if it's an initial user -->
          <th mat-header-cell *matHeaderCellDef (click)="isInitialUser || !editMode ? {} : onEditColumn(colIndex)">
            <span class="clickable">{{ checklist.columns[colIndex].name }}</span>
          </th>
          <td
            mat-cell
            *matCellDef="let element; let rowIndex = index;"
            (click)="edit(rowIndex, columnName)"
            [ngStyle]="getRowStyle(element, colIndex)">
            <span *ngIf="readOnlyInitialChecklists || !isEdit(rowIndex, columnName) else editItemCell">
              <!-- Display coloured circle if hex code value -->
              <span
                *ngIf="isColourHexCode(element.data[columnName]) else standardDisplay"
                class="coloured-circle max-input-width"
                [ngStyle]="{'background-color': element.data[columnName]}">
              </span>
              <ng-template #standardDisplay>
                <div *ngIf="!checklist.columns[colIndex].isIcon else iconDisplay">
                  {{ (element.data[columnName] != null) ? element.data[columnName] : '-' }}
                </div>
              </ng-template>
            </span>
            <ng-template #iconDisplay>
              <div class="icon-grey" *ngIf="element.data[columnName]?.icon">
                <mat-icon
                    matSuffix
                    matTooltip="{{ element.data[columnName]?.message }}">
                    {{element.data[columnName]?.icon}}
                  </mat-icon>
              </div>
            </ng-template>
            <ng-template #editItemCell>
              <div class="edit-table-cell-content-container">
                <mat-form-field floatLabel="never"
                                class="max-input-width cell-form-field"
                                *ngIf="!checklist.columns[colIndex].isIcon else iconDisplay">
                  <!-- Generic text input -->
                  <input
                    *ngIf="!hasCellOptions(element['uuid'], colIndex)"
                    matInput
                    [class.empty-input]="!element.data[columnName]"
                    [placeholder]="element.dataPlaceholder[columnName]"
                    [(ngModel)]="element.data[columnName]"
                    (ngModelChange)="markFormAsDirty()"
                    (focusout)="edit(null, null);">
                  <!-- User provided options -->
                  <mat-select
                    *ngIf="hasCellOptions(element['uuid'], colIndex)"
                    disableOptionCentering
                    [placeholder]="('PROJECT.COMMON.PLEASE_SELECT' | anessaTranslation: trigger)"
                    [(ngModel)]="element.data[columnName]"
                    (ngModelChange)="markFormAsDirty(); edit(null, null);">
                    <mat-select-trigger>
                      <!-- Display coloured circle if hex code value -->
                      <span
                        *ngIf="isColourHexCode(element.data[columnName]) else standardDisplay"
                        class="coloured-circle"
                        [ngStyle]="{'background-color': element.data[columnName]}">
                    </span>
                      <ng-template #standardDisplay>{{ element.data[columnName] }}</ng-template>
                    </mat-select-trigger>
                    <mat-option
                      *ngFor="let option of getCellOptions(element['uuid'], colIndex)"
                      [value]="option">
                      <!-- Display coloured circle if hex code value -->
                      <span
                        *ngIf="isColourHexCode(option) else standardOption"
                        class="coloured-circle"
                        [ngStyle]="{'background-color': option}">
                    </span>
                      <ng-template #standardOption>{{ option }}</ng-template>
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <!-- cell options popup -->

                <div class="clickable cell-plus-margin">
                  <mat-icon *ngIf="editMode"
                            class="cell-plus-icon"
                            (click)="onCellOptionsClick(element, colIndex)"
                  >edit_note</mat-icon>
                </div>
              </div>

            </ng-template>
          </td>
        </ng-container>
      </ng-container>

      <!-- Remove Control Column -->
      <ng-container matColumnDef="removeControl">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let i = index;">
          <button
            *ngIf="editMode"
            mat-icon-button
            disableRipple
            class="clickable max-input-width"
            color="warn"
            (click)="onRemoveRow(i)">
            <mat-icon class="icon-right-padding">clear</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedControls; sticky: true" class="control-row"></tr>
      <tr mat-header-row class="row2" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <app-save-cancel-buttons
    [bypassPermissions]="this.isProjectInput"
    [formValid]="checklistForm.valid && !readOnlyInitialChecklists"
    [showSave]="!hideSaveButton()"
    [showSidebarButtons]="!hideSidebarButton()"
    (saveClick)="onSave()"
    (cancelClick)="onCancel()">
  </app-save-cancel-buttons>
</div>
